import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "toDoWidgetEl",
  class: "to-do-widget content is-60-40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, " ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoWidgetButton = _resolveComponent("ToDoWidgetButton")!
  const _component_ToDoComponent = _resolveComponent("ToDoComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ToDoWidgetButton, {
      id: "toDoWidgetButton",
      count: _ctx.openedCount,
      isActive: _ctx.isShowWidget,
      onOnClick: _ctx.onToggleWidget
    }, null, 8, ["count", "isActive", "onOnClick"]),
    (_ctx.isTeleport)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#toDoWidget"
        }, [
          _createVNode(_Transition, {
            onBeforeEnter: _ctx.beforeEnter,
            onBeforeLeave: _ctx.beforeLeave
          }, {
            default: _withCtx(() => [
              (_ctx.isShowWidget)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_Transition, { onBeforeEnter: _ctx.beforeEnterToDo }, {
                      default: _withCtx(() => [
                        (_ctx.showToDo)
                          ? (_openBlock(), _createBlock(_component_ToDoComponent, {
                              key: 0,
                              showCloseButton: true,
                              selectedToDoInList: _ctx.selectedToDoInList,
                              onOnHideToDoWidget: _ctx.onHideToDo,
                              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, null, 8, ["selectedToDoInList", "onOnHideToDoWidget"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["onBeforeEnter"])
                  ], 512))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onBeforeEnter", "onBeforeLeave"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}